import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-end gap-4" }
const _hoisted_2 = { class: "flex-1 min-w-[250px]" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "w-24" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "w-24" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "flex gap-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_12 = { class: "inline-block px-3 py-1.5 rounded-full text-xs font-semibold bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-200 border border-blue-300 dark:border-blue-700" }

import { inject } from 'vue'
import { useTheme } from '../../../utils/useTheme'
import type { TaskSentinelFilters } from '../../../types/task-sentinel'


export default /*@__PURE__*/_defineComponent({
  __name: 'TaskSentinelFilters',
  props: {
    filters: {},
    loading: { type: Boolean },
    resultCount: {}
  },
  emits: ["update-search", "update-offset", "update-limit", "load-data", "reset"],
  setup(__props: any, { emit: __emit }) {

const theme = inject('theme', useTheme())

const props = __props

const emit = __emit

const updateSearch = (value: string) => {
  emit('update-search', value)
}

const updateOffset = (value: number) => {
  emit('update-offset', value)
}

const updateLimit = (value: number) => {
  emit('update-limit', value)
}

const clearSearch = () => {
  emit('update-search', '')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
      'border rounded-lg p-4'
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1.5" }, [
          _createElementVNode("span", { class: "text-blue-500" }, "🔍"),
          _createTextVNode(" Search ")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", {
            value: _ctx.filters.search,
            type: "text",
            placeholder: "Search teams, emails, IDs... (Ctrl+K)",
            class: "w-full px-3 py-2 pr-8 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white placeholder-gray-400",
            onInput: _cache[0] || (_cache[0] = ($event: any) => (updateSearch(($event.target as HTMLInputElement).value)))
          }, null, 40, _hoisted_4),
          (_ctx.filters.search)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full flex items-center justify-center text-lg leading-none bg-gray-200 dark:bg-gray-600 text-gray-600 dark:text-gray-300 hover:bg-blue-500 hover:text-white transition-all",
                title: "Clear search",
                onClick: clearSearch
              }, " × "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1.5" }, [
          _createElementVNode("span", { class: "text-blue-500" }, "📍"),
          _createTextVNode(" Offset ")
        ], -1)),
        _createElementVNode("input", {
          value: _ctx.filters.offset,
          type: "number",
          min: "0",
          class: "w-full px-3 py-2 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (updateOffset(parseInt(($event.target as HTMLInputElement).value) || 0))),
          onKeypress: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('load-data')), ["enter"]))
        }, null, 40, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1.5" }, [
          _createElementVNode("span", { class: "text-blue-500" }, "📊"),
          _createTextVNode(" Limit ")
        ], -1)),
        _createElementVNode("input", {
          value: _ctx.filters.limit,
          type: "number",
          min: "1",
          max: "200",
          class: "w-full px-3 py-2 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white",
          onInput: _cache[3] || (_cache[3] = ($event: any) => (updateLimit(parseInt(($event.target as HTMLInputElement).value) || 50))),
          onKeypress: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.$emit('load-data')), ["enter"]))
        }, null, 40, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          disabled: _ctx.loading,
          class: _normalizeClass([
            'px-5 py-2 rounded-md font-semibold shadow-sm transition-all flex items-center gap-2 text-white',
            _ctx.loading
              ? 'bg-blue-400 cursor-not-allowed'
              : 'bg-blue-500 hover:bg-blue-600 active:scale-95'
          ]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('load-data')))
        }, [
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass([_ctx.loading ? 'animate-spin' : '', 'w-4 h-4']),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            }, null, -1)
          ]), 2)),
          _cache[11] || (_cache[11] = _createTextVNode(" Load Data "))
        ], 10, _hoisted_10),
        _createElementVNode("button", {
          class: "px-5 py-2 rounded-md font-semibold shadow-sm transition-all bg-gray-500 hover:bg-gray-600 active:scale-95 text-white",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('reset')))
        }, " ↺ Reset ")
      ])
    ]),
    (_ctx.filters.search && _ctx.resultCount !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.resultCount) + " result" + _toDisplayString(_ctx.resultCount === 1 ? '' : 's') + " found ", 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})